import { render, staticRenderFns } from "./invoiceAndStockComparison.vue?vue&type=template&id=2a19b8bf&"
import script from "./invoiceAndStockComparison.vue?vue&type=script&lang=js&"
export * from "./invoiceAndStockComparison.vue?vue&type=script&lang=js&"
import style0 from "./invoiceAndStockComparison.vue?vue&type=style&index=0&id=2a19b8bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports